import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
//import { HeaderComponent } from './header/header.component';
import { HomeComponent } from './home/home.component';
import { JwtHelperService, JWT_OPTIONS } from "@auth0/angular-jwt";
import { HttpClientModule } from "@angular/common/http";
import { SharedModule } from "../shared/shared.module";
import { TranslateModule } from "@ngx-translate/core";
import { INTERCEPTOR_PROVIDER } from "./interceptors/interceptor-provider";
import { NavBarComponent } from "./nav-bar/nav-bar.component";
import { HeaderComponent } from "./header/header.component";
import { VendorApplicationComponent } from "./vendor-application/vendor-application.component";
import { AuthenticationModule } from "../modules/authentication/authentication.module";
import { ReactiveFormsModule } from '@angular/forms';
import { NextPreviousBackComponent } from "./vendor-application/next-previous-back/next-previous-back.component";
import { BankAccountComponent } from "./bank-account/bank-account.component";
import { FileUploadComponent } from "../shared/components/file-upload/file-upload.component";
import { ProfileComponent } from "./profile/profile.component";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MessageComponent } from "./message/message.component";
import { FormsModule } from '@angular/forms'; // Import FormsModule
import { MatDialogModule } from "@angular/material/dialog";
import { ToastrModule } from "ngx-toastr";
import { CommonModule } from "@angular/common";
import { CarouselModule } from 'ngx-owl-carousel-o';
import { TableModule } from "primeng/table";
import { EmailTemplatesComponent } from "./email-templates/email-templates.component";
import { ManageVendorsComponent } from "./manage-vendors/manage-vendors.component";
import { ExecuteQueryComponent } from "./execute-query/execute-query.component";
import { FAQsComponent } from "./faqs/faqs.component";

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        HttpClientModule,
        SharedModule,
        TranslateModule,
        AuthenticationModule,
        ReactiveFormsModule,
        CarouselModule,
        MatTooltipModule,
        FormsModule,
        TableModule,
        ToastrModule.forRoot({
            timeOut: 5000,
            positionClass: 'toast-top-right',
            preventDuplicates: true,
            toastClass: 'toast-custom',
            tapToDismiss: true,
            closeButton: true
          })
    ],
    exports: [
        NextPreviousBackComponent,
        FileUploadComponent
    ],
    declarations: [
        HomeComponent,
        HeaderComponent,
        NavBarComponent,
        VendorApplicationComponent,
        NextPreviousBackComponent,
        BankAccountComponent,
        FileUploadComponent,
        ProfileComponent,
        MessageComponent,
        EmailTemplatesComponent,
        ManageVendorsComponent,
        ExecuteQueryComponent,
        FAQsComponent
    ],
    providers: [
        INTERCEPTOR_PROVIDER
    ],
})
export class CoreModule {}